/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AfterViewInit, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LoggerService } from '../../shared/services/logger.service';
import { Store } from '@ngxs/store';
import videoJs from 'video.js';

@Component({
    selector: 'dash-gis-report-video',
    templateUrl: './report-video-dialog.component.html',
})
export class ReportVideoDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('target', { static: false }) target: ElementRef;

    // player: videoJs.Player;

    constructor(
        private logger: LoggerService,
        private ngZone: NgZone,
        private store: Store,
        private dialogRef: MatDialogRef<ReportVideoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected data
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {
        // const timer = setInterval(() => {
        //     if (this.target) {
        //         clearInterval(timer);
        //         this.player = videoJs(this.target.nativeElement);
        //     }
        // }, 100);
    }

    ngOnDestroy() {
        // this.player.dispose();
    }

    public close() {
        this.ngZone.run(() => this.dialogRef.close());
    }

    get videoSource() {
        return this.data;
    }
}
